import { Environment } from '@ilg-core/inscalar-web'

export const getInscalarAppEnv = (): Environment =>
    process.env.NEXT_PUBLIC_APP_ENV === 'production' ? 'prod' : 'test'
